import React, {useEffect, useState} from 'react';
import bulk from "./../../images/bulk.svg"
import cloud from "./../../images/cloud.svg"
import Add from "./../../images/add.svg"
import Category from "./../../images/Category.svg"
import Search from "./../../images/Search.svg"
export default function Progress(props) {
    const [step, setStep] = useState(0);
    const {page} = props;
    useEffect(() => {
        switch(page) {
            case 'main': setStep(0); break;
            case 'permissions': setStep(1); break;
            case 'db-info': setStep(2); break;
            case 'Upload File': setStep(3); break;
            case 'Select Event Log': setStep(4); break;
            case 'Data Preview': setStep(5); break;
        }
    },[page])
    return (
        <div className="progress d-flex justify-content-between align-items-center">
            <div className="active"></div>
            <div className={`active ${step === 1 && 'stop_1'}`}>
                {step === 1 &&
                <img src={bulk}/>}
            </div>
            <div className={`${step > 3 && 'active'} ${step === 2 ? 'stop_2' : step === 3 && 'stop_3'}`}>
                {step === 2 &&
                <img src={cloud}/>}
                {step === 3 &&
                <img src={Add}/>}
            </div>
            <div className={`${step === 5 && 'active'} ${step === 4 && 'stop_4'}`}>
                {step === 4 &&
                <img src={Category}/>}
            </div>
            <div className={step === 5 && 'stop_5'}>
                {step === 5 &&
                <img src={Search}/>}
            </div>
            <div className={`bar step_${step}`}></div>
        </div>
    );
}
